/* eslint-disable react/prop-types */
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import Popover from '@material-ui/core/Popover'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import FilterListIcon from '@material-ui/icons/FilterList'
import SearchIcon from '@material-ui/icons/Search'
import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state'
import React, { useState } from 'react'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { ValidatorForm } from 'react-material-ui-form-validator'
import { useDispatch, useSelector } from 'react-redux'
import { endOfDay, format, startOfDay } from 'date-fns'

import BadgeGlobal from '../../components/Badge'
import { fetchBirthRelatoryInit } from '../BirthRelatoryActions'

export default function Filter(props) {
  const items = useSelector(state => state.birth_relatory.items)

  const dispatch = useDispatch()
  const { classes } = props
  const [form, setForm] = useState({
    name: '',
    birthday_start: null,
    birthday_end: null,
  })

  const onSubmit = e => {
    e.preventDefault()
    const birthdayStart = form.birthday_start
      ? format(startOfDay(new Date(form.birthday_start)), 'yyyy-MM-dd HH:mm:ss')
      : null
    const birthdayEnd = form.birthday_end
      ? format(endOfDay(new Date(form.birthday_end)), 'yyyy-MM-dd HH:mm:ss')
      : null

    const data = {
      ...form,
      birthday_start: birthdayStart,
      birthday_end: birthdayEnd,
    }
    dispatch(fetchBirthRelatoryInit(null, data, null))
  }

  return (
    <Tooltip title="Filter list">
      <PopupState variant="popover" popupId="demo-popup-popover">
        {popupState => (
          <div>
            <IconButton aria-label="filter list" {...bindTrigger(popupState)}>
              <BadgeGlobal form={form} items={items}>
                <FilterListIcon />
              </BadgeGlobal>
            </IconButton>
            <Popover
              {...bindPopover(popupState)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <Box p={2} className={classes.popover}>
                <div className={classes.root}>
                  <ValidatorForm className={classes.form} onSubmit={onSubmit}>
                    <Grid
                      container
                      className={classes.gridContainer}
                      spacing={1}
                      justify="center"
                      alignItems="center"
                    >
                      <Grid item xs={4}>
                        <TextField
                          onChange={e =>
                            setForm({ ...form, name: e.target.value })
                          }
                          label="Nome"
                          className={classes.inputFilter}
                          fullWidth
                          margin="dense"
                          variant="outlined"
                          value={form.name}
                        />
                      </Grid>

                      <Grid item xs={4}>
                        <KeyboardDatePicker
                          clearable
                          value={form.birthday_start}
                          label="Aniversário Inicial"
                          fullWidth
                          views={['date']}
                          clearLabel="Limpar"
                          invalidDateMessage="Data inválida"
                          autoOk
                          margin="dense"
                          inputVariant="outlined"
                          onChange={date =>
                            setForm({ ...form, birthday_start: date })
                          }
                          format="dd/MM"
                        />
                      </Grid>

                      <Grid item xs={4}>
                        <KeyboardDatePicker
                          clearable
                          value={form.birthday_end}
                          label="Aniversário Final"
                          fullWidth
                          views={['date']}
                          clearLabel="Limpar"
                          invalidDateMessage="Data inválida"
                          autoOk
                          margin="dense"
                          inputVariant="outlined"
                          onChange={date =>
                            setForm({ ...form, birthday_end: date })
                          }
                          format="dd/MM"
                        />
                      </Grid>

                      <Grid item xs>
                        <Button
                          type="submit"
                          color="primary"
                          fullWidth
                          variant="contained"
                          className={classes.submit}
                          onClick={popupState.close}
                        >
                          <SearchIcon />
                          {` Filtrar`}
                        </Button>
                      </Grid>
                    </Grid>
                  </ValidatorForm>
                </div>
              </Box>
            </Popover>
          </div>
        )}
      </PopupState>
    </Tooltip>
  )
}
